export default {"src":"/statics/ecommerce/_next/static/media/big-b.0f3813ae.svg","height":75,"width":61,"blurWidth":0,"blurHeight":0};